// LICENSE_CODE ZON
'use strict'; /*jslint ts:true, react:true*/
import React, {useContext, useMemo} from 'react';
import {Settings_context} from '../settings_ctx';
import {Editor} from '../../../shared/editor/editor';
import {Svg_img} from '../ui/svg_img';
import {Link} from '../ui/link';
import {use_countries} from '../ui/forms/use_countries';
import zcountry from 'zcountry';
import {hola_countries} from 'hola_opt';
import cn from 'classnames';
import styles from './popular_locations_for_domain.module.less';

const get_connection = (type: string | null = null, nr_connection = 0,
  prev_connection = 0)=>
{
    const robust_cond = type=='agents' ? 10 : 100;
    if (nr_connection > robust_cond)
        return <Svg_img id={'svg/icon/robust_connection.svg'} w={16} h={16}/>;
    if (nr_connection > 0)
        return <Svg_img id={'svg/icon/online.svg'} w={16} h={16}/>;
    if (prev_connection > 0)
    {
        return <Svg_img id={'svg/icon/temporarily_unavailable.svg'}
          w={16} h={16}/>;
    }
    return <Svg_img id={'svg/icon/unavailable.svg'} w={16} h={16}/>;
};

interface i_country_card_props {
    country_value: string;
    name: string;
    flag: React.ReactElement;
    nr_connection: number;
    prev_connection: number;
}

const Country_card = (props: i_country_card_props)=>{
    const {name, flag, nr_connection, prev_connection, country_value} = props;
    const {theme} = useContext(Settings_context);
    return <Link className={styles.country_card}
      to={`/vpn/${country_value.toLowerCase()}`}>
      <div className={styles.country_flag}>{flag}</div>
      <div className={styles.country_info}>
        <p className={cn([theme.p3, theme.med, theme.color_n700])}>{name}</p>
        <div className={styles.country_availability}>
          <p className={theme.p4}>Availability</p>
          {get_connection('agents', nr_connection, prev_connection)}
        </div>
      </div>
    </Link>;
};

interface i_popular_locations_for_domain_props {
    domain: string;
    header?: string;
    subheader?: string;
}

export const Popular_locations_for_domain = (
props: i_popular_locations_for_domain_props)=>{
    const default_header = `Popular locations for ${props.domain}`;
    const default_subheader = 'Content libraries differ by country. '
        +'Try one of these popular locations.';
    const {header = default_header,
        subheader = default_subheader} = props;
    const {theme} = useContext(Settings_context);
    const {countries} = use_countries('f32', cn(styles.locations_flag_wrap,
        theme.xs, theme.P), styles.locations_flag_icon, null, null, true);
    const data = useMemo(()=>countries.map(el=>{
        let _title = el.title;
        if (el.value=='GB')
            _title = 'United Kingdom';
        return {
              ...el,
              title: _title,
              c_name: zcountry.code2hiphen_label(el.value),
              agents: hola_countries?.agents &&
                  hola_countries?.agents[el.value]||0,
              prev_agents: hola_countries?.prev_data?.agents &&
                  hola_countries?.prev_data?.agents[el.value]||0,
            };
        }).filter(c=>!['RU', 'IN'].includes(c.value))
        .sort((a, b)=>b.agents-a.agents)
        .slice(0, 6), []);
    return <div className={styles.wrapper}>
      <div className={cn([styles.container, theme.container])}>
        <div className={styles.text_container}>
          <h3>{header}</h3>
          <p className={theme.u2}>{subheader}</p>
        </div>
        <div className={styles.country_cards}>
          {data.map(c=><Country_card key={c.value}
            name={c.title} flag={c.rendered_item} country_value={c.value}
            nr_connection={c.agents} prev_connection={c.prev_agents}/>)}
        </div>
      </div>
    </div>;
};

interface i_popular_locations_for_domain_editor_props {
    value: i_popular_locations_for_domain_props;
    on_change: (new_val: i_popular_locations_for_domain_props)=>void;
}

export const Popular_locations_for_domain_editor = (
props: i_popular_locations_for_domain_editor_props)=>{
    const {value, on_change} = props;
    return <Editor value={value} on_change={on_change}
      editors={[
        {key: 'header', label: 'Header', type: 'text'},
        {key: 'subheader', label: 'Subheader', type: 'text'},
      ]}/>;
};
